import { GameManager } from './types';
import { v2 } from './helpers';

export function getZeroGameManager(): GameManager {
  const zeroGameManager: GameManager = {
    serverSession: '',
    isMobile: false,
    localTimeZone: '',
    pageTitle: 'thnk',
    preventScroll: true,
    clientReady: false,

    //entities
    objectControllerMap: {}, //object controllers per type

    gameObjectServerIdTable: {}, //objects per serverId

    registry: {
      byType: new Map(),
    },

    objectEventData: {}, //sync object data from server

    entities: [],
    cursor: null,
    autoTypeControllers: [],
    mainRoom: null,
    animations: [],

    //flags
    doUpdatePhysics: true,
    paused: false,
    isConnectedToServer: false,

    //other
    userEmit: {
      mousePos: v2(),
      mouseClicked: false,
      emitInterval: 1,
      lastEmitTime: 0,
      cursorText: '',
      lastEmitX: -1,
      lastEmitY: -1,
      lastEmitText: '',
    },
    mousePos: v2(),
    lastMousePos: v2(),

    lastEntityId: 0,
    gameObjectIdTable: {},

    backgroundMusic: null,
    requestCloseOverlayEntities: false,
    user: {
      sessionId: '',
      accessToken: '',
      refreshToken: '',
      firstName: '',
      lastName: '',
      profilePicSizes: {
        thumb: null,
        small: null,
        medium: null,
        large: null,
      },
      // profilePicUri: '',
      email: '',
      slug: '',
      cmsRole: false,
    },
    DOM: null,
    rootFontSizePx: 0,
    rootUnitSizePx: 0,

    space: null,
    spaceBG: null,

    settings: {
      offScreenCanvasEnabled: false,
      helpUri: '',
      permissionsHelpUri: '',
      videoCallInfoTitle: '',
      videoCallInfoContent: '',
    },
    textRenderCtx: null,

    performanceTier: 0,
    performanceTierChanged: false,
  };

  return zeroGameManager;
}
